import moment from 'moment';
import _ from 'lodash';
import 'moment/locale/th';

moment.locale('th');

export const formatDate = (_d, options = {}, format = 'dddd D MMM YYYY') => {
  const { noEra, hasDayPrefix, twoDigitYear } = options;
  let seperateSymbol = ' ';
  if (_.includes(format, '/')) {
    seperateSymbol = '/';
  }
  const arr = moment(_d).format(format).split(seperateSymbol);
  const y = +arr.pop();
  const dateWithOutYear = arr.join(seperateSymbol);
  let year = y > 2200 ? y : y + 543;
  let date;
  if (twoDigitYear) {
    year = year.toString().substring(2);
  }
  date = `${dateWithOutYear}${seperateSymbol}${year}`;
  if (hasDayPrefix || false) {
    date = `วัน${date}`;
  }
  date = date.replace('พฤหัสบดี', 'พฤหัส');

  return date;
};

export const formateDateTime = (momentDate, momentDateFormat) => {
  return `${formatDate(momentDate, {}, momentDateFormat)} เวลา ${momentDate.format('HH:mm')} น.`;
};

export const formatRegisterClosedDate = (_d) => {
  // if (_d && moment(_d).startOf('day').valueOf() >= moment().startOf('day').valueOf()) {
  //   return moment(_d).startOf('day');
  // }
  return moment(_d).startOf('days');
};

export const chatTime = (_d) => {
  const diff = moment().diff(moment(_d), 'hour');
  if (diff < 24 && moment().get('date') === moment(_d).get('date')) {
    return moment(_d).format('HH:mm น.');
  } else if (diff < 48 && moment().get('date') - moment(_d).get('date') === 1) {
    return 'เมื่อวานนี้';
  }
  return formatDate(_d, { noEra: true }, 'D MMM YYYY');
};

export const dateTh = {
  monday: 'วันจันทร์',
  tuesday: 'วันอังคาร',
  wednesday: 'วันพุธ',
  thursday: 'วันพฤหัส',
  friday: 'วันศุกร์',
  saturday: 'วันเสาร์',
  sunday: 'วันอาทิตย์',
};

export default formatDate;
